/**
 * Aviso entre abas: a cotação foi editada pela equipe.
 *
 * A edição abre o portal em outra aba, e a planilha continuava mostrando os
 * valores antigos até alguém clicar em "Atualizar Respostas". A aba do portal
 * avisa ao salvar, e a planilha aberta atualiza as linhas de fornecedor na hora.
 *
 * BroadcastChannel só alcança abas do mesmo navegador e da mesma origem. Sem
 * suporte, nada quebra: vale a atualização automática ao voltar o foco.
 */
const CANAL = "sistema-cotacao:cotacao-editada";

export interface CotacaoEditada {
  planilhaId: string;
  orcamentoId: string;
}

export function avisarCotacaoEditada(aviso: CotacaoEditada): void {
  if (typeof BroadcastChannel === "undefined") return;
  const canal = new BroadcastChannel(CANAL);
  canal.postMessage(aviso);
  canal.close();
}

/** Devolve a função que para de ouvir. */
export function ouvirCotacaoEditada(
  aoReceber: (aviso: CotacaoEditada) => void,
): () => void {
  if (typeof BroadcastChannel === "undefined") return () => {};
  const canal = new BroadcastChannel(CANAL);
  canal.onmessage = (e: MessageEvent<CotacaoEditada>) => {
    if (e.data?.planilhaId && e.data?.orcamentoId) aoReceber(e.data);
  };
  return () => canal.close();
}
